import { render, staticRenderFns } from "./btns.vue?vue&type=template&id=92594692"
import script from "./btns.vue?vue&type=script&lang=js"
export * from "./btns.vue?vue&type=script&lang=js"
import style0 from "./btns.vue?vue&type=style&index=0&id=92594692&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports